export class GetSnapshotResponse {
    'snapshot';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshot",
            "baseName": "snapshot",
            "type": "Snapshot",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetSnapshotResponse.attributeTypeMap;
    }
    constructor() {
    }
}
